/* src/app/components/whatsapp-unsubscribe/whatsapp-unsubscribe.component.scss */
.plane-logo {
  width: 108px;
  height: 78px;
  flex-shrink: 0;
}
.bell {
  color: #000;
  font-family: var(--Font-Family-Barlow-Semi-Condensed, "Barlow Semi Condensed");
  font-size: 18.15px;
  font-style: normal;
  font-weight: var(--Font-Weight-semibold, 600);
  line-height: 24.957px;
  letter-spacing: var(--Letter-Spacing-0, 0);
  border-radius: 16.015px;
  background: #43C0F6;
  display: flex;
  padding: 4px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5.338px;
  position: absolute;
  right: 88px;
  top: 39px;
}
.header {
  display: flex;
  padding: 14.82px 24.701px;
  justify-content: center;
  align-items: center;
  gap: 12.35px;
  border-radius: 40px 40px 0 40px;
  background: #F3F3F3;
  color: #000;
  text-align: center;
  font-family: "League Spartan";
  font-size: 28px;
  font-style: normal;
  font-weight: var(--Font-Weight-semibold, 600);
  line-height: 28px;
  letter-spacing: var(--Letter-Spacing-0, 0);
}
.whatsapp-icon {
  position: absolute;
  left: 231px;
  top: 145px;
  width: 21px;
  height: 21.939px;
}
.info-messsage {
  color: #000;
  text-align: center;
  font-family: var(--Font-Family-Barlow-Semi-Condensed, "Barlow Semi Condensed");
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: var(--Letter-Spacing-0, 0);
}
button {
  padding: 9.88px 24.701px;
  border-radius: 123.503px;
  background: var(--blue-500, #43C0F6);
  color: var(--neutral-50, #FFF);
  font-family: "League Spartan";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 29.641px;
}
button:disabled {
  background: var(--blue-200, #A9E2FB);
}
button:active {
  opacity: 0.8;
}
/*# sourceMappingURL=whatsapp-unsubscribe.component-HUVYXBKG.css.map */
